export default __webpack_public_path__ + "static/media/topic.61672e1a.svg";